import {Header, Anchor, Box, ResponsiveContext, Menu, Image, Text} from 'grommet';
import {CaretDown, Grommet as GrommetIcon, Menu as MenuIcon, Twitter} from 'grommet-icons';
import styled from "styled-components";

import logo2 from "./logo_2.png";

const StyledBox = styled(Box)`
    transition: .5s;
    :before {
        border-radius:50%;
        background: #FFFFFF;
        transition: .5s;
        transform: scale(.9);
        z-index: -1;
    }

:hover:before {
  transform: scale(1.2);
  box-shadow: 0 0 15px #ffffff;
  filter: blur(3px);
}

:hover {
  color: #ffffff;
  box-shadow: 0 0 10px #333333;
}

*:focus {
    outline: none;
}
`;
// text-shadow: 0 0 15px #000000
// 99b3ff

export default function HeaderGBar(props) {
    const bgLight = "light-1";
    return (
        // <Grommet theme={grommet}>
        <Header background="light-4" height="105px" pad={{"right": "medium"}}>
            {/*<Box*/}
            {/*    fill="horizontal"*/}
            {/*    flex="grow"*/}
            {/*/>*/}
            {/*<Anchor*/}
            {/*    href="https://tools.grommet.io/"*/}
            {/*    icon={<GrommetIcon color="brand" />}*/}
            {/*    label="Grommet Tools"*/}
            {/*/>*/}
            <ResponsiveContext.Consumer>
                {size =>
                    size === 'small' ? (
                        <>
                            <Box justify="start">
                                <Text size="large" weight="bold">China, Debt, Climate and Nature</Text>
                                <Text pad="2px" size="small">Opportunities for Financial Stability</Text>
                            </Box>
                            <Box justify="end">
                                <Menu
                                    a11yTitle="Navigation Menu"
                                    dropProps={{align: {top: 'bottom', right: 'right'}}}
                                    icon={<MenuIcon color="brand"/>}
                                    items={[
                                        {
                                            label: <Box pad="small">Global Outlook</Box>,
                                            onClick: () => props.changeModule("outlook"),
                                        },
                                        {
                                            label: <Box pad="small">China Debt Exposure</Box>,
                                            onClick: () => props.changeModule("cde"),
                                        },
                                        {
                                            label: <Box pad="small">Environmental Threats</Box>,
                                            onClick: () => props.changeModule("es"),
                                        },
                                        {
                                            label: <Box pad="small">Opportunities</Box>,
                                            onClick: () => props.changeModule("opp"),
                                        },
                                        {
                                            label: <Box pad="small">Data</Box>,
                                            onClick: () => props.changeModule("data"),
                                        },
                                        {
                                            label: <Box pad="small">About</Box>,
                                            onClick: () => props.changeModule("about"),
                                        },
                                    ]}
                                />
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box
                                direction="column"
                                fill="vertical"
                            >
                                <Box
                                    fill="vertical"
                                    alignContent="start"
                                    align="start"
                                    alignSelf="start"
                                    pad="3px"
                                >
                                    <Image
                                        // margin="small"
                                        src={logo2}
                                        fill="vertical"
                                        // width="auto"
                                        // height="80%"
                                        fit="contain"
                                    >
                                    </Image>
                                </Box>
                                <Text size="1.8rem" weight="bold">China, Debt, Climate and Nature</Text>
                                <Text pad="2px" size="medium">Opportunities for Financial Stability</Text>
                            </Box>
                            <Box justify="end" direction="row" gap="medium" fill>
                                <StyledBox
                                    onClick={() => props.changeModule('outlook')}
                                    background={props.module === "outlook" ? "#bebecc" : ""}
                                    // fill="vertical"
                                    direction="row"
                                    alignContent="center"
                                    basis="small"
                                    // flex="grow"
                                    justify="center"
                                    pad={{left: "small"}}
                                >
                                    <Anchor
                                        label="Global Outlook"
                                        alignSelf="center"
                                    />
                                </StyledBox>
                                <StyledBox
                                    background={props.module === "opp" || props.module === "es" || props.module === "cde" ? "#bebecc" : ""}
                                    // fill="vertical"
                                    // alignContent="center"
                                    direction="row"
                                    alignContent="center"
                                    basis="small"
                                    // flex="grow"
                                    justify="center"
                                >
                                    <Menu
                                        a11yTitle="Explore"
                                        label={<Text color="#111111" weight="bold">Explore</Text>}
                                        dropProps={{align: {top: 'bottom', left: 'left'}}}
                                        dropBackground={{"color": "light-2", "opacity": "weak"}}
                                        icon={<CaretDown/>}
                                        items={[
                                            {
                                                label: <Box pad="small">China Debt Exposure</Box>,
                                                onClick: () => props.changeModule('cde'),
                                            },
                                            {
                                                label: <Box pad="small">Environmental Stress</Box>,
                                                onClick: () => props.changeModule('es'),
                                            },
                                            {
                                                label: <Box pad="small">Opportunities</Box>,
                                                onClick: () => props.changeModule('opp'),
                                            },
                                        ]}
                                    />
                                </StyledBox>
                                <StyledBox
                                    background={props.module === "data" ? "#bebecc" : ""}
                                    // fill="vertical"
                                    // alignContent="center"
                                    basis="xsmall"
                                    // flex="grow"
                                    onClick={() => props.changeModule('data')}
                                    justify="center"
                                >
                                    <Anchor
                                        label="Data"
                                        alignSelf="center"
                                    />
                                </StyledBox>
                                <StyledBox
                                    background={props.module === "about" ? "#bebecc" : ""}
                                    // fill="vertical"
                                    // alignContent="center"
                                    basis="xsmall"
                                    // flex="grow"
                                    onClick={() => props.changeModule('about')}
                                    justify="center"
                                >
                                    <Anchor
                                        label="About"
                                        alignSelf="center"
                                    />
                                </StyledBox>
                                <Box
                                    direction="column"
                                    justify="center"
                                    onClick={() => window.open("http://www.twitter.com/GDP_Center")}
                                >
                                    <Twitter size="medium"/>
                                </Box>
                                {/*<Box*/}
                                {/*    background={ props.module==="feedback" ? bgLight : "" }*/}
                                {/*    // fill="vertical"*/}
                                {/*    // alignContent="center"*/}
                                {/*    basis="xsmall"*/}
                                {/*    // flex="grow"*/}
                                {/*    justify="center"*/}
                                {/*>*/}
                                {/*    <Anchor*/}
                                {/*        onClick={ () => props.changeModule('feedback') }*/}
                                {/*        label="Feedback"*/}
                                {/*        alignSelf="center"*/}
                                {/*    />*/}
                                {/*</Box>*/}
                            </Box>
                        </>
                    )
                }
            </ResponsiveContext.Consumer>
        </Header>
        // </Grommet>
    );
}